import COLORS from '@/constants/colors';
import { Tab, Tabs } from '@mui/material';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { NavigationTabItem } from './UiModel';

export function NavigationTabs(props: {
  links: NavigationTabItem[];
  omitOutlet?: boolean;
}) {
  const navigate = useNavigate();
  const location = useLocation();

  const index = props.links.findIndex((item: NavigationTabItem) =>
    location.pathname.endsWith(item.to)
  );

  const handleChange = (selected: number) => navigate(props.links[selected].to);

  return (
    <>
      <Tabs
        value={index === -1 ? '' : index}
        sx={{
          borderBottom: `1px solid ${COLORS.gray_200}`,
          textAlign: 'left',
          paddingLeft: { xs: '16px', md: '0px' },
        }}
        variant="scrollable"
        scrollButtons="auto"
        onChange={(e, tab) => handleChange(tab)}
      >
        {props.links.map((item, index) => {
          return (
            <Tab
              key={`nav_tab_${index}`}
              label={item.label}
              sx={{
                textTransform: 'none',
                paddingLeft: index === 0 ? '0px' : '16px',
                display: 'inline',
                textAlign: 'left',
                minWidth: 'auto',
              }}
            />
          );
        })}
      </Tabs>
      {!props.omitOutlet && <Outlet />}
    </>
  );
}
